import { createSelector } from '@reduxjs/toolkit';

export const selectMap = createSelector((store: any) => store, store => store.map);
export const selectDragging = createSelector(selectMap, map => map.dragging);
export const selectOffset = createSelector(selectMap, map => map.offset);
export const selectUser = createSelector(selectMap, map => map.user);
